import { useRequiredContext } from "@redotech/react-util/context";
import SpotlightIcon from "@redotech/redo-icons/cursor-box.svg";
import SpotlightFilledIcon from "@redotech/redo-icons/cursor-box_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";

export const SpotlightsItems = memo(function SpotlightsItems() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.spotlightsHref }}
      FilledIcon={SpotlightFilledIcon}
      friendlyName="Spotlights"
      id="spotlights"
      UnfilledIcon={SpotlightIcon}
    />
  );
});
